import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { fetchOrganization } from "~/thunks/organizationThunks";
import type { CloudImage, TGCPFile } from "~/types/CloudImage";
import type { Report, ReportsItem } from "~/types/reports";
import { israeliOrganizationIds } from "./constants";

  interface ReportsState {
    leftViewSize: string | null;
    rightViewSize: number | null;
    bottomViewSize: number | null;
    showRightView: boolean;
    showBottomView: boolean;
    defectRatingMode: boolean;
    report: Report;
    tabName: string;
    item: ReportsItem | TGCPFile | CloudImage | null;
    image: CloudImage | null;
    };

const initialState: ReportsState = {
  leftViewSize: "20rem",
  rightViewSize: null,
  bottomViewSize: null,
  showRightView: false,
  showBottomView: true,
  defectRatingMode: false,
  report: {
    name: '',
    view: 'left-narrow',
    order: 0, 
  },
  tabName: 'general',
  item: null,
  image: null,
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    // setSize: (state, action: PayloadAction<{ view: 'left' | 'right'; size: number }>) => {
    //   if (action.payload.view === 'left') {
    //     state.leftViewSize = action.payload.size;
    //   } else if (action.payload.view === 'right') {
    //     state.rightViewSize = action.payload.size;
    //   }
    // },
    setImage: (state, action: PayloadAction<CloudImage | null>) => {
      state.image = action.payload;
    },
    setDefectRatingMode: (state, action: PayloadAction<boolean>) => {
      state.defectRatingMode = action.payload;
    },
    setItem: (state, action: PayloadAction<any>) => {
      state.item = action.payload;
    },
    setTabName: (state, action: PayloadAction<string>) => {
      state.tabName = action.payload;
    },
    setReport: (state, action: PayloadAction<Report>) => {
      state.report = action.payload;
        state.item = null; // Reset item when report changes
        state.image = null;
     switch (action.payload.view) {
          case 'left-narrow':
            state.leftViewSize = "20rem";
            state.showBottomView = true;
            break;
          case 'left-wide':
            state.leftViewSize = "53vw";
            state.showBottomView = true;
            break;
          case 'equal-no-bottom':
            state.leftViewSize = "40vw";
            state.showBottomView = false;
            break;
          case 'left-narrow-no-bottom':
            state.leftViewSize = "20rem";
            state.showBottomView = false;
            break;
          case 'full-page':
            state.leftViewSize = null;
            state.showBottomView = false;
            break;

          default:
            break;
        }
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchOrganization.fulfilled, (state, action: PayloadAction<any>) => {
      if (action.payload) {
        if (israeliOrganizationIds.includes(action.payload.id)) {
          state.defectRatingMode = true;
        } else {
          state.defectRatingMode = false;
        }
        // state.organization = action.payload;
      }
    });
  },
});

export const { setImage, setDefectRatingMode, setItem, setTabName, setReport } = reportsSlice.actions;
export default reportsSlice.reducer;
export const selectReports = (state: any) => state.reports;
export const selectItem = (state: any) => state.reports.item;
export const selectTabName = (state: any) => state.reports.tabName;
export const selectReport = (state: any) => state.reports.report;
export const selectLeftViewSize = (state: any) => state.reports.leftViewSize;
export const selectDefectRatingMode = (state: any) => state.reports.defectRatingMode;
export const selectImage = (state: any) => state.reports.image;



